<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
    </div>
    <div v-show="open" class="layer" id="postCodePop">
      <button type="button" class="btnClose" @click="open = false"></button>
      <div class="inner">
        <vue-daum-postcode @complete="complete" />
      </div>
    </div>
    <button type="button" class="btn btnWhite btnFull" @click="postcode">
      {{item.value[lang]}}
    </button>
    <div v-if="passed" class="mt15">
      <input type="text" class="input" :value="value" disabled>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Postcode',
  props: [
    'id',
    'item',
    'itemSetting',
    'lang',
    'locale'
  ],
  computed: {
    ...mapGetters({
      submitData: 'submit/getSubmitData'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    value: {
      get () {
        const data = typeof (this.submitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.submitData.find(x => x.id === this.id).value
        return data
      },
      set (value) {
        const passed = !this.itemSetting.action.isRequired ? null : value !== ''
        const data = {
          id: this.id,
          value: value,
          passed: passed
        }
        this.$store.commit('submit/setValue', data)
      }
    },
    passed () {
      return this.submitData && this.submitData.find(x => x.id === this.id)
        ? this.submitData.find(x => x.id === this.id).passed
        : null
    }
  },
  mounted () {
    const pop = document.getElementById('postCodePop')
    if (pop) {
      document.getElementById('app').appendChild(pop)
    }
  },
  destroyed () {

  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    setPopover (isPopover) {
      this.$emit('setPopover', isPopover ? this.id : '')
    },
    postcode () {
      this.open = true
      this.setPopover(true)
    },
    complete (info) {
      const value = `${info.sido} ${info.sigungu}`
      const data = {
        id: this.id,
        value: value,
        passed: true
      }
      this.$store.commit('submit/setValue', data)
      this.open = false
      this.setPopover(false)
    }
  }
}
</script>

<style lang="scss">
#postCodePop {
  z-index: 9999999;
  .inner {
    padding: 5px;
  }
  .vue-daum-postcode-container {
    height: 560px !important;
  }
}
</style>
